import { render, staticRenderFns } from "./studentsList.vue?vue&type=template&id=3d4a2f4a&scoped=true"
import script from "./studentsList.vue?vue&type=script&lang=js"
export * from "./studentsList.vue?vue&type=script&lang=js"
import style0 from "./studentsList.vue?vue&type=style&index=0&id=3d4a2f4a&prod&lang=less"
import style1 from "./studentsList.vue?vue&type=style&index=1&id=3d4a2f4a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d4a2f4a",
  null
  
)

export default component.exports